import lazyContractStateRaw from '../markdown/posts/2026-06-02-lazy-contract-state-fetching-for-midnight.md';
import bitcoinUtxosRaw from '../markdown/posts/2026-09-29-bitcoin-utxos.md';

// Add new posts here. Order doesn't matter; the export below sorts by date desc.
const RAW_POSTS: string[] = [lazyContractStateRaw, bitcoinUtxosRaw];

export type Post = {
    title: string;
    date: string;
    slug: string;
    summary: string;
    body: string;
    /** Standalone page under `public/` that this post opens instead of rendering `body`. */
    href?: string;
};

function parsePost(raw: string): Post | null {
    const match = raw.match(/^---\n([\s\S]*?)\n---(?:\n([\s\S]*))?$/);
    if (!match) return null;
    const [, fmRaw, body = ''] = match;
    const meta: Record<string, string> = {};
    for (const line of fmRaw.split('\n')) {
        const colon = line.indexOf(':');
        if (colon === -1) continue;
        const key = line.slice(0, colon).trim();
        const value = line
            .slice(colon + 1)
            .trim()
            .replace(/^["']|["']$/g, '');
        if (key) meta[key] = value;
    }
    return {
        title: meta.title || 'Untitled',
        date: meta.date || '',
        slug: meta.slug || '',
        summary: meta.summary || '',
        body: body.trim(),
        href: meta.href || undefined,
    };
}

export const POSTS: Post[] = RAW_POSTS.map(parsePost)
    .filter((p): p is Post => p !== null && !!p.slug)
    .sort((a, b) => b.date.localeCompare(a.date));

export const findPost = (slug: string): Post | undefined => POSTS.find((p) => p.slug === slug);
